export default "__VITE_ASSET__d1d8f751__"